import React from "react";
import { Box } from "@mui/material";

const SRC = "/images/site_logo.png";
// The asset is 100x50, so the box has to keep 2:1 or the mask letterboxes.
const ASPECT = 2;

/**
 * The site wordmark.
 *
 * site_logo.png is pure white artwork on transparency, so it vanished against
 * the light sidebar and top bar — visible only in dark mode. Painting it as a
 * mask over a themed colour keeps the single asset legible in both modes.
 */
export default function BrandLogo({ height = 28, color = "text.primary", sx }) {
  return (
    <Box
      role="img"
      aria-label="Geopro"
      sx={{
        height,
        width: height * ASPECT,
        flexShrink: 0,
        bgcolor: color,
        WebkitMaskImage: `url(${SRC})`,
        maskImage: `url(${SRC})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        ...sx,
      }}
    />
  );
}
